<template>
    <div id="listBill">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title venderinvoice">  Vendor Invoice Line Item List</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <!-- Comment due to various Vendor Invoice Type -->
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportLineItemCheck()">
                              <i class="fp-export"></i> Export Line Item
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-invoice-list">
                        <data-table-filter-config :moduleName="'billList'" ref="filterBill" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <p v-if="importBatchProcess" id="importInvBatchMsg" class="alert-success p-2">Current batch {{importBatchNum}} is processing. Please wait while we import vendor invoice !!</p>
                        <p v-if="statusBatchProcess" id="importInvBatchMsg" class="alert-success p-2">Current batch {{importBatchNum}} is processing. Please wait while we change vendor invoice status !!</p>
                        <p v-if="errorFound" id="importInvErrorMsg" class="alert-success p-2">Current batch {{importBatchNum}} processed.<router-link class="color-blue" v-bind:to="errorLink" target="_blank" @click.native="errorLink = '';errorFound = false;"> Click Here</router-link> to check import error!</p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                        <section :class="'ml-0 bg-white '">
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'billLineItemList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listBillLineItemsTable"
                                    mode="remote"
                                    title="Vendor Invoice Line Items"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'bottom',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: false,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">
                                    <div slot="emptystate">
                                      No Data Found.
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange">
                                </custom-pagination>

                        </section>

                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="field-error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import VueSSE from 'vue-sse'
Vue.use(VueSSE);

import EventBus from "../event-bus";
var contex

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
let msgServer;

export default {
    name: "BillLineItemsList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Vendor Invoice Line Item List | " +process.env.COPYRIGHT_NAME
    },
    components: {
        
        
        vendorInvoicePreview: () => import('@/components/accounting/VendorInvoicePreview'),
        pdfPrintPreview: () => import('@/components/accounting/PdfPrintPreview'),
        
    },
    mixins:[commonMixins,dataTableMixins,contractMixins],
    data: () => ({
        pageKey: '_vendor_invoice_line_item_list_',
        batchProcess:0,
        batchNum:"",
        firstLoad : 0,
        userColumns:[],
        check_number: '',
        flag:'entered',
        ach_check_number: '',
        checknumber: '',
        columns: [
            {
                label: 'Invoice',
                field: 'bill_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Bill", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: 'Voucher',
                field: 'voucher_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "# Voucher", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
              label: 'Voucher Type',
              field: 'voucher_type',
              filterable: true,
              fpFieldType:"text",
              hidden:false,
            },
            {
                label: 'Vendor PO',
                field: 'po_number',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "#Vendor PO", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: '#Work Order',
                field: 'work_order_no',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "#Vendor PO", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                html:true
            },
            {
                label: 'Vendor',
                field: 'vendor',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Email',
                field: 'vendoremail',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Email", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Location',
                field: 'location',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Vendor", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Amount",
                field: "amount",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                    label: 'Invoice Date',
                    field: 'bill_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
            },
            {
                label: 'Due Date',
                field: 'due_date',
                hidden:false,
                fpFieldType:"date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Invoice Add Date',
                field: 'invoice_add_date',
                hidden:false,
                fpFieldType:"date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Assignee',
                field: 'vendor_assignee_id',
                hidden:false,
                fpFieldType:"text",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Assignee", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Verified By',
                field: 'verified_by_name',
                hidden:false,
                fpFieldType:"text",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Verified By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Approved By',
                field: 'approved_by_name',
                hidden:false,
                fpFieldType:"text",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Approved By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Approved At',
                field: 'approved_at',
                hidden:false,
                fpFieldType:"date",
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Approved By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Monthly Payable',
                field: 'monthly_payable',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Monthly Payable", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems:["Yes","No"]
                }
            },
            {
                label: "Post Month",
                field: "post_month",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Post Month", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Post Year",
                field: "post_year",
                fpFieldType:"integer",
                hidden:false,
                filterable: true,
                type: 'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Post Year", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: "Settled",
                field: "is_settled",
                fpFieldType:"option",
                hidden:false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Post Year", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Yes','No'], // dropdown (with selected values) instead of text input
                    filterFn: this.onColumnFilter, //custom filter function that
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        permissions:[],
        loading:false,
        cantAccessPage:"",
        statusArr:[
            {text:'Entered',value:'entered'},
            {text:'Verified',value:'verified'},
            {text:'Approved',value:'approved'},
            {text:'Disapproved',value:'disapproved'},
            {text:'Paid',value:'paid'},
            {text:'Void',value:'void'},
        ],
        importBatchProcess:false,
        statusBatchProcess:false,
        importBatchNum:"",
        importBatchId:0,
        batchError:false,
        batchErrorMsg:"",
        errorFound:false,
        path:"",
        action:"list",
        loggedInUser:0
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_vendor_invoice') {
                    self.cantAccessPage = true;
                }
            });
        }
    },
    mounted: function () {

        this.getPermissions();

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            if (userObj.id > 0) {
                this.loggedInUser = userObj.id;
            }
        }
    },
    methods: {
        cancelAll: function (cancelAll) {
          this.$refs.listBillLineItemsTable.unselectAllInternal();
        },
        selectionChanged(param) {
            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            // console.log(self.computed.selectedRows);
            var rowData = self.$refs['listBillLineItemsTable'].selectedRows;
            console.log(rowData);
        },
        exportCheck: function() {
            var self = this;
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['listBillLineItemsTable'].selectedRows;
            count = data.length;
            if(this.serverParams.selectedAll == true){
                actionFlag = "";
            }else if(count != 0 && count <= 100){
                actionFlag = "export";
            }
            this.exportReports(actionFlag);
        },
        exportLineItemCheck: function() {
            var self = this;
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['listBillLineItemsTable'].selectedRows;
            count = data.length;
            if(count != 0 && count < 100){
              actionFlag = "export_line_item";
            }
            this.exportLineItemReports(actionFlag);
        },
        checkBatchStatus:function(){
            var self =  this;
            this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.importBatchId, { format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;
                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1") {
                        self.importBatchProcess = false;
                        if (data.other_params != undefined && data.other_params != null && data.other_params != "") {
                            self.errorLink = data.other_params;
                            self.errorFound = true;
                        }else{
                            self.errorLink = "";
                            self.errorFound = false;
                        }
                        self.loadList();
                        sse.close();
                    }else if (data.status == "2") {
                        self.importBatchProcess = false;
                        self.errorFound = false;
                        self.errorLink = "";
                        self.batchError = true;
                        self.batchErrorMsg = data.message;
                        sse.close();
                    }
                });
            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });
        },
        pdfPrint: function() {
          var data = this.$refs['listBillLineItemsTable'].selectedRows;
          var ids = []
          for (var i = 0; i < data.length; i++) {
            ids.push(this.$refs['listBillLineItemsTable'].selectedRows[i].id)
          }
          this.openPdfPrintTab(ids)
        },
        loadList: function() {
              var self = this;

              var data = this.$refs['listBillLineItemsTable'].selectedRows;
              var use = [];
              for (var i = 0; i < data.length; i++) {
                  use.push(this.$refs['listBillLineItemsTable'].selectedRows[i].id)
              }

              var fields = {
                  page: self.serverParams.page,
                  perPage: self.serverParams.perPage,
                  filters: self.serverParams.columnFilters,
                  sort: self.serverParams.sort,
                  flag:self.flag,
                  userId: self.loggedInUser,
                  all:self.serverParams.selectedAll,
                  id:use,
                  action:self.action
              };
              self.loading = true;
              self.firstLoad = 1;
              $.ajax({
                  url: process.env.ROOT_API + "/bill-line-items/list",
                  type: "POST",
                  data: fields,
                  headers: this.ajxHeaders,
                  dataType: "json",
                  crossDomain: true,
                  success: function (data) {
                      self.loading = false;

                      console.log(data);
                      if (data.status == "success") {
                          if ( self.action == "export_line_item" || self.action == "export_line_item_queue") {

                              if ( data.code == "201" ) {
                                  alert(data.message);
                              } else {

                                  if ( self.action == "export" || self.action == "export_line_item" ) {

                                      self.excel = data.content.web;
                                      var save = document.createElement("a");
                                      save.href = self.excel;
                                      save.download = data.content.web;
                                      save.target = "_blank";

                                      document.body.appendChild(save);
                                      save.click();
                                      document.body.removeChild(save);

                                  } else {

                                      self.batchProcess = 1;
                                      self.batchNum = data.content;
                                  }

                              }

                              self.action = "list";
                              self.loadList();
                              return;

                          } else {
                              self.rows = data.content.row;
                              self.totalRecords = data.content.totalRecords;
                          }
                      }
                      //reset action to list so when send requset again it will consider as list
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      self.action = "list";
                      self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-list');
                  }
              });
        }
    }
}
</script>
<style scoped>
.page-title.venderinvoice{
    width: 48% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/accounting/BillLineItemsList.vue